import React, {
  ComponentPropsWithoutRef,
  memo,
  MouseEvent,
  ReactNode,
} from "react";

import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { ActionIcon, Box } from "@mantine/core";

import { ReactComponent as Dots } from "assets/icons/dots-horizontal.svg";
import { BlockchainEntity } from "components/BlockchainEntityTitle/types";
import CollectionMenu from "~/features/collections/sections/ContractCollectionDashboard/menu/CollectionMenu";
import DraftMenu from "~/features/collections/sections/ContractCollectionDashboard/menu/DraftMenu";

export type SubMenuItem = {
  label: ReactNode;
  icon: ReactNode;
} & ComponentPropsWithoutRef<"menuitem">;
const BlockchainEntityMenu = ({ entity }: { entity: BlockchainEntity }) => {
  const showContextMenu = useFeatureFlags(
    FEATURE_FLAGS.SHOW_COLLECTIONS_CONTEXT_MENU
  );

  if (!showContextMenu) return <></>;

  const menuButton = (
    <ActionIcon>
      <Dots />
    </ActionIcon>
  );

  return (
    <Box onClick={(e: MouseEvent<HTMLDivElement>) => e.preventDefault()}>
      {entity.isDraft ? (
        <DraftMenu menuButton={menuButton} entity={entity} />
      ) : (
        <CollectionMenu menuButton={menuButton} entity={entity} />
      )}
    </Box>
  );
};

export default memo(BlockchainEntityMenu);
